module.exports = __webpack_public_path__ + "assets/32a8a4cb37f8fd4ec082904ead6bfc3a.mp3";